module.exports = __webpack_public_path__ + "img/kuchyn.73f5b9d0.svg";